import styled, { css } from 'styled-components'
import { tokens } from '../../../assets/tokens'
import { safeDarken, safeAlpha } from '../../../utils/color'

const { color } = tokens

// Réplica de ActionButton (buttonVariant="filled") del Storybook de Velora.
// El fondo sigue siendo el color del cliente (props.color / theme.primary), no #0176BC.
const BackButtonStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  && {
    min-height: 40px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    color: ${props => props.theme.textPrimary};
    background: ${props => props.color};
    border-radius: 8px;
    box-shadow: none;
    padding: 10px 14px;
    outline: none;
    border: 1.5px solid transparent;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    :hover {
      background: ${props => safeDarken(props.color)};
    }

    ${props =>
      props.styledType === 'reset' &&
      css`
        min-height: 0;
        background-color: transparent;
        color: ${color.text.primary};
        padding: 0;
        border: 0;
        font-weight: 500;
        font-size: 14px;

        :hover {
          background-color: transparent;
        }
      `};

    ${props =>
      props.styledType === 'invert' &&
      css`
        background-color: ${color.background.default};
        color: ${props.color};
        border-color: ${props.color};
        :hover {
          background-color: ${safeAlpha(props.color, 0.08)};
        }
      `};

    ${props =>
      props.disabled === true &&
      css`
        /* Deshabilitado de Velora (brandInteractive.primaryDisabled): el muted no se distinguía del fondo */
        cursor: not-allowed;
        background: ${color.brandInteractive.primaryDisabled};
        color: ${color.text.disabled};
        border-color: transparent;
        :hover {
          background: ${color.brandInteractive.primaryDisabled};
        }
      `};
  }
`

export default BackButtonStyled
